import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { SectionsListAsTiles } from '../../../components/SectionsListAsTiles';
import { sidebarLayoutDataHooks } from '../sidebarLayoutDataHooks';

export interface SectionsListProps {
  currentStep: ParticipantStep | null;
  onStepChosen: (step: ParticipantStep) => void;
}

export const SectionsList: React.FC<SectionsListProps> = ({
  currentStep,
  onStepChosen,
}) => {
  return (
    <SectionsListAsTiles
      dataHook={sidebarLayoutDataHooks.sectionsListTiles()}
      dataHookForStepsList={sidebarLayoutDataHooks.stepsListTiles()}
      currentStepId={currentStep?.id}
      onStepChosen={onStepChosen}
    />
  );
};
